module.exports = __webpack_public_path__ + "img/baiwankuiyuan.be7dc753.png";